var module = angular.module('Directives');
module.directive('ngDatePicker', function($filter, $timeout) {
    return {
        restrict: 'A',
        scope: {
            ngModel: '=?',
            ngParams: '=',
            ngDatePicker: '='
        },
        link: function($scope, element, attrs) {

            $timeout(function() {
                var defaultParams = {
                    nextText: '',
                    prevText: '',
                    showOtherMonths: true,
                    showAnim: false,
                    dateFormat: 'yy-mm-dd',
                    onSelect: function(date) {
                        $scope.$apply();
                        $scope.ngDatePicker && $scope.ngDatePicker.onSelect ?
                            $scope.ngDatePicker.onSelect(element.datepicker('getDate')) :
                            false;
                        $scope.ngModel = date;
                        $scope.$apply();
                    }
                };

                $scope.$watch('ngParams', function() {
                    if (!$scope.ngParams) return;
                    angular.extend(defaultParams, $scope.ngParams);
                    element.datepicker('option', defaultParams);
                });
                $scope.$watch('ngModel', function() {
                    if (!$scope.ngModel) return;

                    if ($scope.ngModel instanceof Array) {
                        $scope.ngModel = $scope.ngModel[0];
                    }
                    element.datepicker("setDate", $scope.ngModel);
                });

                element.datepicker(defaultParams);

                var isFocus;
                element.on('mousedown', function() {
                    isFocus = element.is(':focus');
                }).on('click', function() {
                    isFocus ? element.datepicker('show') : false;
                });
            })

        }
    }
});



// WEBPACK FOOTER //
// ./js/directives/bbaDatePicker.js